import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../assets/Blog.css';

const Blog = () => {

    const navigate = useNavigate();

    const [blogs, setBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalBlogs, setTotalBlogs] = useState(0);
    const [loading, setLoading] = useState(true);

    // ✅ Safe total pages
    const totalPages = Math.max(1, Math.ceil(totalBlogs / rowsPerPage));

    // ✅ Fetch Blogs
    useEffect(() => {
        setLoading(true);

        axios.get(`https://www.samriddhidevelopers.in/backend/getBlogs.php?page=${currentPage}&limit=${rowsPerPage}`)
            .then(res => {
                setBlogs(res.data.blogs || []);
                setTotalBlogs(res.data.total || 0);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });

    }, [currentPage, rowsPerPage]);

    // ✅ Scroll to top on page change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="blog-container">

            {/* ✅ Loading State */}
            {loading && <p style={{ textAlign: "center" }}>Loading...</p>}

            {/* ✅ Empty State */}
            {!loading && blogs.length === 0 && (
                <p style={{ textAlign: "center" }}>No blogs found</p>
            )}

            {/* ✅ Blog List */}
            {!loading && blogs.map((blog) => (
                <div key={blog.id} className="blog-item">

                    <h3
                        className="blog-title-link"
                        onClick={() => navigate(`/blog/${blog.slug}`)}
                    >
                        {blog.title}
                    </h3>

                    <p className="blog-preview">
                        {blog.content.replace(/<[^>]+>/g, '').substring(0, 150)}...
                    </p>

                </div>
            ))}

            {/* ✅ Pagination */}
            {!loading && blogs.length > 0 && (
                <div className="pagination">

                    <button
                        onClick={() => changePage(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        ‹ Prev
                    </button>

                    {[...Array(totalPages)].map((_, i) => (
                        <button
                            key={i}
                            className={currentPage === i + 1 ? 'active' : ''}
                            onClick={() => changePage(i + 1)}
                        >
                            {i + 1}
                        </button>
                    ))}

                    <button
                        onClick={() => changePage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next ›
                    </button>

                </div>
            )}

            {/* ✅ Rows Selector */}
            {!loading && blogs.length > 0 && (
                <div className="rows-selector">
                    {[5, 10, 20].map((num) => (
                        <button
                            key={num}
                            className={rowsPerPage === num ? 'active' : ''}
                            onClick={() => {
                                setRowsPerPage(num);
                                setCurrentPage(1);
                            }}
                        >
                            {num} rows
                        </button>
                    ))}
                </div>
            )}

        </div>
    );
};

export default Blog;